import React, {useState} from 'react'
import PropTypes from 'prop-types'
import actions from 'redux-auto'
import i18n from 'i18next'
import DropdownSelect from '#components/m/DropdownSelect'
import {useNachweisTypes, options} from './NachweisTypeOptions'
import Text from '#components/a/Text'
import Api from '#services/api'
import ModalByProps from '#components/m/ModalByProps'
import Headline from '#components/a/Headline'
import {isAfter, addDays} from 'ag-common/facades'

function AusbildungsnachweisType({
  canChangeAusbildungsnachweistyp,
  isChangable,
  selectedNachweisTyp,
  onSelectionChanged,
  hasQualifikationen,
}) {
  return !canChangeAusbildungsnachweistyp || !isChangable ? (
    <span>{selectedNachweisTyp.label}</span>
  ) : (
    <DropdownSelect
      options={useNachweisTypes(hasQualifikationen, selectedNachweisTyp)}
      selectedOption={selectedNachweisTyp}
      handleSelect={opt => onSelectionChanged(opt.value)}
      isDisabled={!isChangable}
      dataTestId="ausbildungsnachweisCell"
    />
  )
}

AusbildungsnachweisType.propTypes = {
  canChangeAusbildungsnachweistyp: PropTypes.bool,
  isChangable: PropTypes.bool,
  selectedNachweisTyp: PropTypes.oneOf(options),
  onSelectionChanged: PropTypes.func,
  hasQualifikationen: PropTypes.bool,
}

function AusbildungsnachweisCell(props) {
  const {canChangeAusbildungsnachweistyp, azubi} = props
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [selectedNachweisTyp, setSelectedNachweisTyp] = useState(
    options.find(o => o.value === props.azubi.ausbildungsnachweisTyp),
  )

  const canChangeAusbildungsnachweis = isAfter(addDays(new Date(azubi.ausbildungsstartDate), 60), new Date())

  const closeModal = () => {
    setModalIsOpen(false)
  }

  const abortNachweisTypChange = () => {
    setSelectedNachweisTyp(options.find(o => o.value === props.azubi.ausbildungsnachweisTyp))
    closeModal()
  }

  const openModal = () => {
    setModalIsOpen(true)
  }

  const onSelectNachweisTyp = nachweisTyp => {
    setSelectedNachweisTyp(options.find(o => o.value === nachweisTyp))
    if (selectedNachweisTyp.value !== nachweisTyp) {
      openModal()
    }
  }

  const onConfirmNachweisTyp = async () => {
    const {reloadAzubis} = props
    try {
      await Api.updateAusbildungsnachweisTyp(azubi.id, selectedNachweisTyp.value)
      closeModal()
      reloadAzubis()
    } catch (e) {
      actions.error.writeError({error: e})
    }
  }

  return (
    <div>
      <AusbildungsnachweisType
        canChangeAusbildungsnachweistyp={canChangeAusbildungsnachweistyp}
        isChangable={canChangeAusbildungsnachweis}
        selectedNachweisTyp={selectedNachweisTyp}
        onSelectionChanged={onSelectNachweisTyp}
        hasQualifikationen={!!props.azubi.qualifikationenBerufKey}
      />
      <ModalByProps
        modifier="meineazubis"
        modalIsOpen={modalIsOpen}
        closeModal={abortNachweisTypChange}
        handleConfirm={() => onConfirmNachweisTyp()}>
        <Headline modifier="article" importance={2} text={i18n.t('nachweistyp_change_confirmation_headline')} />
        <Text text={i18n.t('nachweistyp_change_confirmation_bodytext')} />
      </ModalByProps>
    </div>
  )
}

AusbildungsnachweisCell.propTypes = {
  canChangeAusbildungsnachweistyp: PropTypes.bool,
  azubi: PropTypes.shape({
    ausbildungsberuf: PropTypes.number,
    ausbildungsnachweisTyp: PropTypes.string,
    ausbildungsstartDate: PropTypes.any,
    id: PropTypes.any,
  }),
  reloadAzubis: PropTypes.func.isRequired,
}

export default AusbildungsnachweisCell
